import React from 'react';
import { useWatch } from 'react-hook-form';

import { ComponentHelpers } from 'helpers/ComponentHelpers';

import { SelectField, SelectFieldProps } from 'components/forms/fields/SelectField';

type ReleaseQuarterFieldProps = Omit<SelectFieldProps, 'data'>;

const QUARTERS_AHEAD = 8;

const getQuarterOptions = () => {
    const now = new Date();

    let year = now.getFullYear();
    let quarter = Math.floor(now.getMonth() / 3) + 1;

    return Array.from({ length: QUARTERS_AHEAD }, () => {
        const option = {
            value: ComponentHelpers.formatReleaseQuarter(year, quarter),
            label: `Q${quarter} ${year}`,
        };

        if (quarter === 4) {
            year += 1;
            quarter = 1;
        } else {
            quarter += 1;
        }

        return option;
    });
};

const ReleaseQuarterField = ({ name, ...props }: ReleaseQuarterFieldProps) => {
    const value = useWatch({ name }) as string | null | undefined;

    const options = getQuarterOptions();
    const parsed = ComponentHelpers.parseReleaseQuarter(value);

    // A quarter saved before today falls outside the rolling window, so keep it selectable rather than blank.
    if (parsed && !options.some((option) => option.value === value)) {
        options.unshift({ value: value as string, label: `Q${parsed.quarter} ${parsed.year}` });
    }

    return <SelectField {...props} name={name} data={options} placeholder="Select a quarter" />;
};

export { ReleaseQuarterField };
